module.exports = __webpack_public_path__ + "img/bg-main.d65046e1.png";